import LoanTransItem from "../../../components/LoanTranItem";
import TransactionItem from "../../../components/TransactionItem";
import { SiSaltstack } from "react-icons/si";
import { useSelector, useDispatch } from "react-redux";
import { AiOutlineCalculator } from "react-icons/ai";
import { BsArrowDownShort } from "react-icons/bs";
import { BiAbacus } from "react-icons/bi";

import TransactionDetails from "../../../components/TransactionDetails";
import { useState, useEffect, useLayoutEffect } from "react";
import NoTransactionSelected from "../../../components/InitailStatesStores/NoTransactionSelected";
import {
  fetchStoreTransactionUrl,
  fetchAllGoodsOnLoanUrl,
  fetchQueriedTransactionUrl,
  fetchYesterdayTransactionUrl,
  fetchCustomTransactionUrl,
  clearLoanUrl,
  extendLoanUrl,
  returnAllProductUrl,
  supplyAllProductUrl,
  splitPaymentUrl,
  pushPaymentKudaUrl,
} from "../../../api/endpoints";

import EachProductSold from "../../../components/EachProductSold";
/* import { clearLoanUrl, extendLoanUrl, returnAllProductUrl, supplyAllProductUrl, splitPaymentUrl } from "../../../api/endpoints"; */
import { registerReminderForLoan } from "./ConfirmSelection";
import CustomeDateSearch from "../../../components/filter/CustomeDateSearch";
import { refreshUserToken } from "../../../tools/refreshToken";
import { useNavigate } from "react-router-dom";
import noTransaction from "./notransaction.png";
import Spinner, { ButtonLoader } from "../../../components/uxCollections/Loaders";
import NoQueriedTransFOund from "./noqueriedtransfound.png";
import { getAllData, saveData } from "../../../tools/indexdb";
import { emptyQueue, setRefreshTransaction } from "../../../slice/offlineQueue";
import { syncOfflineQueue } from "../../../tools/synOfflineQueue";
import "./QuerriedTrans/queriedTrans.css";
import { uiAlert } from "../../../components/alerts/customAlert/uiAlert";
import SalesBookSkeleton from "../../../components/uxCollections/skeletonLoader/transaction/TransactionSkeleton";
import RegisterPaymentModal from "../../../components/transactionDetailAction/SplitPayment";
import ExtendLoanModal from "../../../components/transactionDetailAction/ExtendDueDates";
import ClearLoanModal from "../../../components/transactionDetailAction/CLearLoan";

/* import NoQueriedTransFOund from "%PUBLIC_URL%/logo192.png"; */

/* fetch list of todays transafact */

const computeTotalAmountOnLoan = (transactions) => {
  let totalLoanedAmount = transactions.reduce(
    (acc, curr) => {
      /* acc.paid = parseInt(acc.paid) + parseInt(curr.operationType.intialPayment); */
      if (curr.transactionDetails.deliveryStatus !== "returned") {
        console.log(curr.operationType.balance, "balance curr", curr.transactionDetails.deliveryStatus);

        acc.loaned = parseInt(acc.loaned) + parseInt(curr.operationType.balance);
      }
      return acc;
    },
    { paid: 0, loaned: 0 },
  );

  return totalLoanedAmount;
};

const CashTransactionComp = ({
  transType,
  loan,
  whichCompToRender,
  openCheckSales,
  setAlertDisplay,
  searchString,
  showQueriedTrans,
  updateShowQueriedTrans,
  socket,
  fetchYesterdayTrans,
  fetchTodayTrans,
  fetchCustomTrans,
  displayedTimeline,
  updateTodayTrans,
  updateTransactionCount,
  setTransactionInsights,
  transID,
  noProductCreated,
}) => {
  console.log("Rendering CashTransaction component");
  const [todaysTransaction, setTodaysTransaction] = useState([]);
  const [todaysTransactionCopy, setTodaysTransactionCopy] = useState([]);
  const [totalBreakdown, setTotalBreakdown] = useState({ paid: "", loaned: "" });
  const [totalCLearedLoanToday, setTotalCLearedLoanToday] = useState(0);
  const [selectedTransact, setSelectedTransact] = useState(null);
  const [allowFetchAllGoodsOnLoan, setAllowFetchAllGoodsOnLoan] = useState(true); // [true, false]
  const [showingAllLoan, setShowingAllLoan] = useState(false); // [true, false]
  const { store } = useSelector((state) => state.store);
  const { user } = useSelector((state) => state.webStoreUser);
  const { count, queue, refreshTransaction } = useSelector((state) => state.offlineQueue);
  const [isLoading, setIsLoading] = useState(true); //
  const [allGoodsOnLoan, setAllGoodsOnLoan] = useState(null);
  const [dueLoanTodayCount, setDueLoanTodayCount] = useState(null);
  const [notSuppliedCount, setNotSuppliedCount] = useState(null);
  const [showingInitailAllLoan, setShowingInitailAllLoan] = useState(false);
  const { employee } = useSelector((state) => state.employee);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (refreshTransaction) {
      console.log("refreshing transaction from cash transaction component");
      fetchTodayTransaction();
    }
  }, []);

  useEffect(() => {
    console.log(store.storeName, "store from cash transaction comp");

    setIsLoading(true);

    if (store) {
      console.log(store.storeName, "store from cash transaction comp inside if");

      getStoreTransactionFromIDB();
    }
  }, [store]);

  /*  useEffect(() => {
    setTodaysTransaction((prev) => {
      // if no query, keep the list as-is
      if (!transID) return prev;

      const q = String(transID).toLowerCase();

      return prev.filter(
        (trans) =>
          Array.isArray(trans.products) &&
          trans.products.some((p) =>
            String(p?.name ?? "")
              .toLowerCase()
              .includes(q)
          )
      );
    });
  }, [transID]); */

  useEffect(() => {
    if (fetchYesterdayTrans) {
      getYesterdayTransactions();
      console.log("fetching yesterday transaction", fetchYesterdayTrans);
      setAllowFetchAllGoodsOnLoan(false);
      setSelectedTransact(null);
      setShowingInitailAllLoan(false);
      setShowingAllLoan(false);
    } else if (fetchTodayTrans) {
      // fetchTodayTransaction();
      getStoreTransactionFromIDB();
      console.log("fetching today transaction");
      //setSelectedTransact(null);
      setAllowFetchAllGoodsOnLoan(true);
      setShowingInitailAllLoan(false);
      setShowingAllLoan(false);
    } else if (fetchCustomTrans) {
      console.log("fetching custom transaction");
      /*   setOpenCustomDataFetch(true); */
      console.log(fetchCustomTrans);
      setAllowFetchAllGoodsOnLoan(false);
      fetchCustomTransaction(fetchCustomTrans.fromDate, fetchCustomTrans.toDate);
      setSelectedTransact(null);
      setShowingInitailAllLoan(false);
      setShowingAllLoan(false);
    }
  }, [fetchYesterdayTrans, fetchTodayTrans, fetchCustomTrans]);

  useEffect(() => {
    setSelectedTransact(null);
  }, [transType]);

  useEffect(() => {
    //  fetchTodayTransaction();

    updateTransactionCount({
      paid: todaysTransaction.filter((trans) => trans.operationType.whichOperation === "cash").length,
      loan: todaysTransaction.filter((trans) => trans.operationType.whichOperation !== "cash").length,
    });
    let dueLoanCount = computeDueLoan(todaysTransaction);
    let notSuppliedCount = computeNotSupplied(todaysTransaction);
    setNotSuppliedCount(notSuppliedCount);
    setDueLoanTodayCount(dueLoanCount);
    setTransactionInsights({
      totalClearedLoanToday: totalCLearedLoanToday,
      totalNotSupplied: notSuppliedCount,
      totalLoanDueToday: dueLoanCount,
      totalAmountOnLoanToday: totalBreakdown.loaned,
      totalPaidAmount: totalBreakdown.paid,
    });
  }, [todaysTransaction]);

  const getStoreTransactionFromIDB = async () => {
    try {
      let storeData = await getAllData(store.storeName);

      let { todaysTransactions = [], todaysClearedLoan = 0 } = storeData?.todayTransactions ?? {};
      let totalBreakdown = todaysTransactions.reduce(
        (acc, curr) => {
          if (curr.operationType.whichOperation === "cash" && curr.transactionDetails.deliveryStatus !== "returned") {
            acc.paid = parseInt(acc.paid) + parseInt(curr.transactionDetails.totalAmount);
          } else {
            if (curr.transactionDetails.deliveryStatus !== "returned") {
              acc.paid = parseInt(acc.paid) + parseInt(curr.operationType.intialPayment);
              acc.loaned = parseInt(acc.loaned) + parseInt(curr.operationType.balance);
            }
          }
          return acc;
        },
        { paid: 0, loaned: 0 },
      );
      updateTodayTrans("Today");
      setTotalBreakdown(totalBreakdown);
      setTotalCLearedLoanToday(todaysClearedLoan);
      setTodaysTransaction(todaysTransactions);
      let dueLoanCount = computeDueLoan(todaysTransactions);
      setDueLoanTodayCount(dueLoanCount);
      setIsLoading(false);
      setTimeout(() => setSelectedTransact(null), 3000);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchTodayTransaction = async () => {
    setIsLoading(true);
    let accessToken = localStorage.getItem("accessToken");
    let storeId = store._id;
    try {
      let response = await fetch(fetchStoreTransactionUrl + storeId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.ok) {
        let { todaysTransactions, todaysClearedLoan, todaysExpenses, clearloanDistribution, store } = await response.json();

        // update indexdb
        if (refreshTransaction) {
          const storeData = await getAllData(store.storeName);

          let updatedStoreData = {
            ...storeData,
            todayTransactions: {
              todaysTransactions: todaysTransactions,
              todaysClearedLoan,
              todaysExpenses,
              clearloanDistribution,
              store,
            },
          };

          console.log("updating indexdb with", updatedStoreData);

          const dbSTATE = await saveData(store.storeName, updatedStoreData);
        }

        let totalBreakdown = todaysTransactions.reduce(
          (acc, curr) => {
            if (curr.operationType.whichOperation === "cash" && curr.transactionDetails.deliveryStatus !== "returned") {
              acc.paid = parseInt(acc.paid) + parseInt(curr.transactionDetails.totalAmount);
            } else {
              if (curr.transactionDetails.deliveryStatus !== "returned") {
                acc.paid = parseInt(acc.paid) + parseInt(curr.operationType.intialPayment);
                acc.loaned = parseInt(acc.loaned) + parseInt(curr.operationType.balance);
              }
            }
            return acc;
          },
          { paid: 0, loaned: 0 },
        );
        console.log(totalBreakdown);
        setTotalBreakdown(totalBreakdown);
        setTotalCLearedLoanToday(todaysClearedLoan);
        setTodaysTransaction(todaysTransactions);
        setTodaysTransactionCopy(todaysTransactions);
        let dueLoanCount = computeDueLoan(todaysTransactions);
        setDueLoanTodayCount(dueLoanCount);

        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(fetchStoreTransactionUrl + storeId, fetchTodayTransaction, navigate);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      dispatch(setRefreshTransaction(false));
    }
  };

  const getYesterdayTransactions = async () => {
    setIsLoading(true);
    console.log("getting yesterday transaction");
    let accessToken = localStorage.getItem("accessToken");
    let storeId = store._id;
    try {
      let response = await fetch(fetchYesterdayTransactionUrl + storeId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.ok) {
        let yesterdaysTransactions = await response.json();
        console.log(yesterdaysTransactions);
        setTodaysTransaction(yesterdaysTransactions); /* set to show yesterdays trans */
        setTodaysTransactionCopy(yesterdaysTransactions);

        let totalBreakdown = yesterdaysTransactions.reduce(
          (acc, curr) => {
            if (curr.operationType.whichOperation === "cash" && curr.transactionDetails.deliveryStatus !== "returned") {
              acc.paid = parseInt(acc.paid) + parseInt(curr.transactionDetails.totalAmount);
            } else {
              if (curr.transactionDetails.deliveryStatus !== "returned") {
                acc.paid = parseInt(acc.paid) + parseInt(curr.operationType.intialPayment);
                acc.loaned = parseInt(acc.loaned) + parseInt(curr.operationType.balance);
              }
            }
            return acc;
          },
          { paid: 0, loaned: 0 },
        );
        console.log(totalBreakdown);
        setTotalBreakdown(totalBreakdown);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCustomTransaction = async (startDate, endDate) => {
    setIsLoading(true);
    console.log("fetching custom transaction", startDate, endDate);
    let accessToken = localStorage.getItem("accessToken");
    let storeId = store._id;
    try {
      let response = await fetch(fetchCustomTransactionUrl + storeId + "/" + startDate + "/" + endDate, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.ok) {
        let customTransactions = await response.json();
        console.log(customTransactions);
        let totalBreakdown = customTransactions.reduce(
          (acc, curr) => {
            if (curr.operationType.whichOperation === "cash" && curr.transactionDetails.deliveryStatus !== "returned") {
              acc.paid = Number(acc.paid) + Number(curr.transactionDetails.totalAmount);
            } else {
              if (curr.transactionDetails.deliveryStatus !== "returned") {
                acc.paid = parseInt(acc.paid) + parseInt(curr.operationType.intialPayment);
                acc.loaned = parseInt(acc.loaned) + parseInt(curr.operationType.balance);
              }
            }
            return acc;
          },
          { paid: 0, loaned: 0 },
        );

        setTotalBreakdown(totalBreakdown);
        setTodaysTransaction(customTransactions);
        setTodaysTransactionCopy(customTransactions);
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const getAllGoodsOnLoan = async () => {
    console.log("getting all goods on loan");
    try {
      let response = await fetch(fetchAllGoodsOnLoanUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.ok) {
        let goodsOnLoan = await response.json();
        setAllGoodsOnLoan(goodsOnLoan);
        console.log(goodsOnLoan);
        setShowingAllLoan(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchGoodsOnloanInitail = async () => {
    console.log("getting all goods on loan");
    setIsLoading(true);
    setAllowFetchAllGoodsOnLoan(false);
    try {
      let response = await fetch(fetchAllGoodsOnLoanUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });

      if (response.ok) {
        let loanTranction = await response.json();
        // setAllGoodsOnLoan(goodsOnLoan);
        let dueLoanCount = computeDueLoan(loanTranction);
        setDueLoanTodayCount(dueLoanCount);
        setTodaysTransaction(loanTranction);
        let totalAmountOnLoan = computeTotalAmountOnLoan(loanTranction);
        setShowingAllLoan(true);
        console.log("total amount on loan", totalAmountOnLoan);
        setTotalBreakdown(totalAmountOnLoan);
        setShowingInitailAllLoan(true);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  const previousLoanWasEdited = (transaction) => {
    /* find this transaction in the prevoiusLoanList and update */
    if (!allGoodsOnLoan || allGoodsOnLoan.length === 0) return;
    setAllGoodsOnLoan((prev) => {
      let index;

      prev.find((trans, i) => {
        if (trans._id.toString() === transaction._id.toString()) {
          index = i;
        }
      });

      prev[index] = transaction;

      return prev;
    });
  };

  return (
    <>
      {isLoading && <SalesBookSkeleton />}
      {todaysTransaction.length > 0 ? (
        <div className='cashransactionWrapper'>
          <div className='transactionList'>
            {/* transtype is true means its a cash transaction false is loan */}
            {transType ? (
              <div className='titleTable2753'>
                <p>Product</p>
                <p>Delivery status</p>
                <p>Unit price</p>
                <p>Total Paid</p>
                <p>View</p>
              </div>
            ) : (
              <div className='titleTable2753'>
                <p>Product</p>
                <p>Loan status</p>
                <p>Initail Pay</p>
                <p>Balance</p>
                <p>View</p>
              </div>
            )}
            {transType
              ? todaysTransaction
                  .filter((trans, i) => trans.operationType.whichOperation === "cash")
                  .filter((trans) => {
                    const query = String(searchString).toLowerCase();

                    return (
                      String(trans.customer?.fullName ?? "")
                        .toLowerCase()
                        .includes(query) ||
                      (Array.isArray(trans.products) &&
                        trans.products.some((p) =>
                          String(p?.name ?? "")
                            .toLowerCase()
                            .includes(query),
                        ))
                    );
                  })
                  .splice(0)
                  .reverse()
                  .map((trans, index) => {
                    return (
                      <TransactionItem key={index} transaction={trans} updateSelectedTrans={setSelectedTransact} currency={user.userCountryCurrencySymbol} />
                    );
                  })
              : todaysTransaction
                  .filter((trans, i) => trans.operationType.whichOperation !== "cash")
                  .filter((trans) => {
                    const query = String(searchString).toLowerCase();

                    return (
                      String(trans.customer?.fullName ?? "")
                        .toLowerCase()
                        .includes(query) ||
                      (Array.isArray(trans.products) &&
                        trans.products.some((p) =>
                          String(p?.name ?? "")
                            .toLowerCase()
                            .includes(query),
                        ))
                    );
                  })
                  .splice(0)
                  .reverse()
                  .map((trans, index) => {
                    return (
                      <LoanTransItem
                        key={index}
                        transaction={trans}
                        updateSelectedTrans={setSelectedTransact}
                        isPreviousLoan={showingInitailAllLoan}
                        currency={user.userCountryCurrencySymbol}
                      />
                    );
                  })}

            {!transType && (
              <>
                {
                  <div onClick={() => !showingAllLoan && getAllGoodsOnLoan()} className='getMoreLoanButton'>
                    <p>{showingAllLoan ? "Showing all goods on loan" : "Get all goods on loan"}</p>
                    {!showingAllLoan && <BsArrowDownShort size={20} />}
                  </div>
                }
                {showingAllLoan &&
                  allowFetchAllGoodsOnLoan &&
                  allGoodsOnLoan &&
                  allGoodsOnLoan?.map((trans, index) => (
                    <LoanTransItem
                      key={index}
                      transaction={trans}
                      updateSelectedTrans={setSelectedTransact}
                      isPreviousLoan={true}
                      currency={user.userCountryCurrencySymbol}
                    />
                  ))}
                {showingAllLoan && allGoodsOnLoan && allGoodsOnLoan.length === 0 && (
                  <p style={{ width: "100%", height: "100px", fontSize: "0.85rem", textAlign: "center" }}>Seem like you dont have any goods on loan</p>
                )}
              </>
            )}
          </div>

          <div className='cdisplayTagDIv2'>
            {transType ? (
              <div>
                <span className='NotSOT45i'>{notSupllSVG}</span>
                <div>
                  <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Not supplied</p>
                  <p className='pNameur664'>{notSuppliedCount}</p>
                </div>
              </div>
            ) : (
              <div>
                <span style={{ backgroundColor: "rgba(255, 252, 245, 1)" }} className='NotSOT45i'>
                  {dueTodaySVG}
                </span>
                <div>
                  <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Credit due today</p>
                  <p className='pNameur664'>{dueLoanTodayCount}</p>
                </div>
              </div>
            )}
            <div>
              <span style={{ backgroundColor: "rgba(246, 251, 246, 1)" }} className='NotSOT45i'>
                {clearLoanSvg}
              </span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Cleared Credit</p>
                <p className='pNameur664'>
                  {user.userCountryCurrencySymbol} {totalCLearedLoanToday.toLocaleString()}
                </p>
              </div>
            </div>
            <div>
              <span style={{ backgroundColor: "rgba(206, 153, 255, 0.1)" }} className='NotSOT45i'>
                {/* <BiAbacus size={30} color='rgba(138, 43, 226, 1)' /> */}
                {LoanAmtSVG}
              </span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Amount on Credit</p>
                <p className='pNameur664'>
                  {user.userCountryCurrencySymbol} {totalBreakdown.loaned.toLocaleString()}
                </p>
              </div>
            </div>
            <div>
              <span style={{ backgroundColor: "rgba(236, 249, 255,0.5)" }} className='NotSOT45i'>
                <BiAbacus size={24} color='rgb(30, 144, 201)' />
              </span>
              <div>
                <p style={{ color: "rgba(25, 25, 25, 1)", fontSize: "0.87rem" }}>Paid Transaction</p>
                <p className='pNameur664'>
                  {user.userCountryCurrencySymbol} {totalBreakdown.paid.toLocaleString()}
                </p>
              </div>
            </div>
          </div>
          {selectedTransact && (
            <TransactionDetails
              selectedTrans={selectedTransact}
              loan={loan}
              updateSelectedTrans={setSelectedTransact}
              updateClearedLoan={setTotalCLearedLoanToday}
              setAlertDisplay={setAlertDisplay}
              updatePreviousLoan={previousLoanWasEdited}
              fetchTodayTransactionFromIBD={getStoreTransactionFromIDB}
              fetchTodayTransaction={fetchTodayTransaction}
              currency={user.userCountryCurrencySymbol}
              socket={socket}
              displayedTimeline={displayedTimeline}
              todayTrans={fetchTodayTrans} // true if today transaction is displayed
              setTodaysTransaction={setTodaysTransaction}
              setAllGoodsOnLoan={setAllGoodsOnLoan}
            />
          )}
        </div>
      ) : (
        <div className='noTransasction23y'>
          <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1750749337/Ihub/noT_nbwoe2.webp"} />
          {/* <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424167/static%20images%20storelens/notransaction_y2afn8.png"} /> */}

          {!transType && (
            <button onClick={fetchGoodsOnloanInitail} className='fetGOL9473'>
              Fetch goods on loan
            </button>
          )}
        </div>
      )}

      {!isLoading && (
        <div className='floatSeDiv66e'>
          <button
            onClick={() => {
              if (noProductCreated) {
                setAlertDisplay({
                  showAlert: true,
                  type: "error",
                  title: "No product created",
                  message: "You need to create a product before you can make a sale",
                });
                return;
              }
              if (employee && !employee.allowedActions.canMakeSales) {
                uiAlert("You don't have permission to make sales. Contact your boss", "error");
                return;
              }
              whichCompToRender("SelectProduct");
            }}
          >
            {" "}
            <SiSaltstack /> Sell items
          </button>
          <button
            onClick={() => {
              if (noProductCreated) {
                console.log("no product created");
                setAlertDisplay({
                  showAlert: true,
                  type: "error",
                  title: "No product created",
                  message: "You need to create a product before you check sales",
                });
                return;
              }
              openCheckSales(true);
            }}
          >
            <AiOutlineCalculator size={20} /> Check Sales
          </button>
        </div>
      )}

      {!isLoading && (
        <div className=' mobileSalesActionBar'>
          <div style={{ width: "100%" }} className='action-left-section'>
            <button
              style={{ flex: "1", color: "#214EC7", backgroundColor: "rgba(34, 83, 206, 0.06)", borderColor: "rgba(34, 83, 206, 0.06)" }}
              onClick={() => openCheckSales(true)}
              className='cancel-sales-btn'
            >
              Check sales
            </button>
          </div>

          <button
            onClick={() => {
              if (employee && !employee.allowedActions.canMakeSales) {
                uiAlert("You don't have permission to make sales. Contact your boss", "error");
                return;
              }
              whichCompToRender("SelectProduct");
            }}
            className='sell-items-btn'
          >
            Sell items
          </button>
        </div>
      )}

      {showQueriedTrans && (
        <QueriedTransaction
          transID={transID}
          setAlertDisplay={setAlertDisplay}
          updateClearedLoan={setTotalCLearedLoanToday}
          updateShowQueriedTrans={updateShowQueriedTrans}
          fetchTodayTransaction={fetchTodayTransaction}
          fetchGoodsOnLoan={getAllGoodsOnLoan}
          socket={socket}
          currency={user.userCountryCurrencySymbol}
          setSelectedTransact={setSelectedTransact}
        />
      )}
    </>
  );
};

export default CashTransactionComp;

const PAYMENT_TYPE_STYLE = {
  cash: { label: "Cash", color: "#16a34a", background: "#dcfce7" },
  POS: { label: "POS", color: "#4f46e5", background: "#e0e7ff" },
  bankTransfer: { label: "Bank Transfer", color: "#ea580c", background: "#ffedd5" },
  mobilePay: { label: "Mobile Pay", color: "#0d9488", background: "#ccfbf1" },
  card: { label: "Card", color: "#0369a1", background: "#f0f9ff" },
  storelensePOS: { label: "StoreLense POS", color: "#475569", background: "#f1f5f9" },
};

// Renders transactionDetails.payments — one row per account it was paid
// through, whether that's a single payment or a split across several.
// Falls back to a plain "Payment mode" line for older transactions that
// don't have a payments[] array yet. All styling is inline (no new CSS
// classes added to this file's stylesheet).
function PaymentsBreakdown({ payments, paymentMode, currency }) {
  if (!payments || payments.length === 0) {
    return (
      <div className='custcont37uD'>
        <div style={{ border: "none" }} className='EacDet35jdh'>
          <span>Payment mode</span>
          <span>{paymentMode}</span>
        </div>
      </div>
    );
  }

  const total = payments.reduce((sum, p) => sum + (Number(p.amount) || 0), 0);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
      {payments.map((p, i) => {
        const style = PAYMENT_TYPE_STYLE[p.paymentType] || PAYMENT_TYPE_STYLE.cash;
        return (
          <div
            key={p._id || i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              padding: "10px 12px",
              border: "1px solid #e5eaf2",
              borderRadius: "10px",
              background: "#ffffff",
            }}
          >
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                flexShrink: 0,
                borderRadius: "6px",
                padding: "3px 8px",
                fontSize: "10.5px",
                fontWeight: 700,
                color: style.color,
                background: style.background,
              }}
            >
              {style.label}
            </span>
            <div style={{ flex: 1, minWidth: 0, display: "flex", flexDirection: "column", gap: "1px" }}>
              <span
                style={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: "#1a2236",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {p.receivingAccountName || "—"}
              </span>
              {(p.reference || p.paidAt) && (
                <span style={{ fontSize: "11px", color: "#7c8aa5" }}>
                  {p.reference ? `Ref: ${p.reference}` : ""}
                  {p.reference && p.paidAt ? " · " : ""}
                  {p.paidAt ? new Date(p.paidAt).toLocaleDateString("en-NG", { day: "numeric", month: "short", year: "numeric" }) : ""}
                </span>
              )}
            </div>
            <span style={{ fontSize: "13px", fontWeight: 700, color: "#1a2236", flexShrink: 0, whiteSpace: "nowrap" }}>
              {currency}
              {Number(p.amount || 0).toLocaleString()}
            </span>
          </div>
        );
      })}
      {payments.length > 1 && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: "10px 12px",
            borderRadius: "10px",
            background: "#f0f4fa",
            fontSize: "13px",
            fontWeight: 700,
            color: "#1a2236",
          }}
        >
          <span>Total paid</span>
          <span>
            {currency}
            {total.toLocaleString()}
          </span>
        </div>
      )}
    </div>
  );
}

// Small inline SVGs matching this file's existing icon style (raw svg,
// stroke=currentColor) — no icon library import assumed.
function ActionBtnIcon({ type }) {
  const common = {
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };
  if (type === "check") {
    return (
      <svg {...common}>
        <path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
        <polyline points='22 4 12 14.01 9 11.01' />
      </svg>
    );
  }
  if (type === "split") {
    return (
      <svg {...common}>
        <polygon points='12 2 2 7 12 12 22 7 12 2' />
        <polyline points='2 17 12 22 22 17' />
        <polyline points='2 12 12 17 22 12' />
      </svg>
    );
  }
  if (type === "undo") {
    return (
      <svg {...common}>
        <path d='M9 14 4 9l5-5' />
        <path d='M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H11' />
      </svg>
    );
  }
  if (type === "clock") {
    return (
      <svg {...common}>
        <circle cx='12' cy='12' r='10' />
        <polyline points='12 6 12 12 16 14' />
      </svg>
    );
  }
  if (type === "package") {
    return (
      <svg {...common}>
        <path d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' />
        <polyline points='3.27 6.96 12 12.01 20.73 6.96' />
        <line x1='12' y1='22.08' x2='12' y2='12' />
      </svg>
    );
  }
  return null;
}

// variant -> colors. "Return All item" is the only red action; everything
// else gets its own color so red doesn't get reused for unrelated actions.
const ACTION_BTN_STYLE = {
  blue: { background: "#2563eb", color: "#ffffff", border: "none" },
  navy: { background: "#1e3a5f", color: "#ffffff", border: "none" },
  red: { background: "#b91c1c", color: "#ffffff", border: "none" },
  outline: { background: "#ffffff", color: "#2563eb", border: "1.5px solid #c7d2fe" },
  disabled: { background: "#e5e7eb", color: "#9ca3af", border: "none" },
};

function ActionBtn({ variant, icon, label, onClick, disabled }) {
  const style = ACTION_BTN_STYLE[disabled ? "disabled" : variant];
  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "8px",
        flex: "1 1 150px",
        minWidth: "130px",
        padding: "12px 18px",
        borderRadius: "10px",
        fontSize: "13.5px",
        fontWeight: 600,
        fontFamily: "inherit",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "opacity 0.15s ease, transform 0.1s ease",
        ...style,
      }}
    >
      <ActionBtnIcon type={icon} />
      <span>{label}</span>
    </button>
  );
}

const QueriedTransaction = ({
  transID,
  setAlertDisplay,
  updateClearedLoan,
  updateShowQueriedTrans,
  fetchTodayTransaction,
  fetchGoodsOnLoan,
  socket,
  currency,
  setSelectedTransact,
}) => {
  const [loading, setLoading] = useState(true);
  const [selectedTrans, setSelectedTrans] = useState(null);
  const [openClearLoanModal, setOpenClearLoanModal] = useState(false);
  const [openExtendLoanModal, setOpenExtendLoanModal] = useState(false);
  const [newExtendDate, setNewExtendDate] = useState("");
  const [isExtendDateValid, setIsExtendDateValid] = useState(false);
  const [openSplitPaymentModal, setOpenSplitPaymentModal] = useState(false);
  const [splitPaymentAmount, setSplitPaymentAmount] = useState(null);
  const [isSplitPaymentAmountValid, setIsSplitPaymentAmountValid] = useState(false);
  const [loanPaymentMode, setLoanPaymentMode] = useState("cash");
  const [showMobileOverlay, setShowMobileOverlay] = useState(false);
  const [showProducts, setShowProducts] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingOper, setLoadingOper] = useState(false);
  const { store } = useSelector((state) => state.store);
  const { count, queue } = useSelector((state) => state.offlineQueue);
  const { employee } = useSelector((state) => state.employee);

  useLayoutEffect(() => {
    fetchQueriedTransaction();
  }, []);
  useEffect(() => {
    console.log("queue", count);
  }, [queue]);

  useEffect(() => {
    if (selectedTrans && new Date(selectedTrans.operationType.dateToPay) < new Date(newExtendDate)) {
      setIsExtendDateValid(true);
      console.log("Valid date");
    } else {
      setIsExtendDateValid(false);
      console.log("Invalid date");
    }
  }, [newExtendDate]);
  useEffect(() => {
    if (selectedTrans && splitPaymentAmount > 0 && splitPaymentAmount <= selectedTrans.operationType.balance) {
      setIsSplitPaymentAmountValid(true);
    } else {
      setIsSplitPaymentAmountValid(false);
    }
  }, [splitPaymentAmount]);

  const returnAllProduct = async () => {
    if (selectedTrans.transactionDetails.deliveryStatus === "returned") {
      uiAlert("All items have already been returned", "error");
      return;
    }

    let payload = {
      transactionID: selectedTrans.transID,
      productIDs: selectedTrans.products.map((product) => product.id),
      customer: selectedTrans.customer.fullName,
      employee,
    };
    let accessToken = localStorage.getItem("accessToken");

    if (window.confirm("Are you sure you want to return all items?\nAll items will be added back to your stock)")) {
      try {
        setLoadingOper(true);
        let response = await fetch(returnAllProductUrl + store._id, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${accessToken}`,
          },
          body: JSON.stringify(payload),
        });

        if (response.ok) {
          console.log("All items returned");
          let { transaction, modifiedProducts_R, updatedStoreProductCollection, store } = await response.json();

          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Items returned",
            message: "All items have been returned to your stock",
          });

          setSelectedTrans(transaction);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingOper(false);
      }
    }
  };

  const supplyAllItem = async () => {
    if (window.confirm("Are you sure you want to supply all items?\nThis can not be undone)")) {
      try {
        setLoadingOper(true);
        let payload = { transactionID: selectedTrans.transID, employee };
        let response = await fetch(supplyAllProductUrl + store._id, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
          body: JSON.stringify(payload),
        });
        if (response.ok) {
          let { transaction } = await response.json();

          setSelectedTrans(transaction);
          setAlertDisplay({
            showAlert: true,
            type: "success",
            title: "Items supplied",
            message: "All items have been supplied to the customer",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoadingOper(false);
      }
    }
  };

  const clearLoan = async (payments, paymentMode, amount) => {
    if (selectedTrans.transactionDetails.deliveryStatus === "returned") {
      uiAlert("All items have already been returned, cannot clear credit.", "error");
      return;
    }

    let payload = { transactionID: selectedTrans.transID, totalClearedAmount: selectedTrans.operationType.balance, paymentMode, payments, amount, employee };
    try {
      let response = await fetch(clearLoanUrl + store._id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        let { transaction, clearedLoanToday } = await response.json();
        console.log(transaction, clearedLoanToday);
        registerReminderForLoan(transaction, socket, store);
        setAlertDisplay({
          showAlert: true,
          type: "success",
          title: "Loan cleared",
          message: "Loan has been cleared. And cleared amount has been updated",
        });

        setSelectedTrans(transaction);
        updateClearedLoan(clearedLoanToday);
        setOpenClearLoanModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const extendLoanFun = async () => {
    if (selectedTrans.transactionDetails.deliveryStatus === "returned") {
      uiAlert("All items have already been returned, cannot extend Credit.", "error");
      return;
    }
    setIsExtendDateValid(false);
    let payload = { transactionID: selectedTrans.transID, newDate: newExtendDate, employee };
    try {
      let response = await fetch(extendLoanUrl + store._id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.ok) {
        let { transaction } = await response.json();
        console.log(transaction);
        registerReminderForLoan(transaction, socket, store);

        setAlertDisplay({
          showAlert: true,
          type: "success",
          title: "Loan extended",
          message: "Loan due date has been extended to " + newExtendDate + "",
        });

        setSelectedTrans(transaction);
        setOpenExtendLoanModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const splitPaymentFun = async (splitPaymentAmount, loanPaymentMode, payment) => {
    setIsSplitPaymentAmountValid(false);
    let payload = {
      transactionID: selectedTrans.transID,
      amountCleared: splitPaymentAmount,
      paymentMode: loanPaymentMode,
      payments: payment,
      amount: splitPaymentAmount,
      employee,
    };

    try {
      let response = await fetch(splitPaymentUrl + store._id, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        let { transaction, clearedLoanToday } = await response.json();
        registerReminderForLoan(transaction, socket, store);
        setAlertDisplay({
          showAlert: true,
          type: "success",
          title: "Payment registered",
          message: "Payment has been registered. And cleared amount has been updated",
        });
        setSelectedTrans(transaction);
        updateClearedLoan(clearedLoanToday);
        setOpenSplitPaymentModal(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchQueriedTransaction = async () => {
    if (!transID) {
      uiAlert("invalid transaction ID, Please provide valid ID ", "error");
      console.log(transID, "invalid transaction ID");

      return;
    }
    console.log("fetching queried transaction");
    try {
      let response = await fetch(fetchQueriedTransactionUrl + transID + "/" + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      });
      if (response.status === 200) {
        let queriedTrans = await response.json();
        console.log(queriedTrans);
        setSelectedTrans(queriedTrans);
        setLoading(false);
      } else if (response.status === 404) {
        setSelectedTrans(null);
        setLoading(false);
      } else {
        uiAlert("something went wrong, try again later", "error");
      }
    } catch (error) {
      console.log(error);
    }
  };

  function truncateTransID(transID) {
    if (!transID || typeof transID !== "string") return "";

    const start = transID.slice(0, 12); // first 12 chars
    const end = transID.slice(-6); // last 6 chars
    return `${start}...${end}`;
  }

  const pushToTerminal = async ({ accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID }) => {
    // try to push to KUDA terminal

    console.log(accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID);

    const url = `${pushPaymentKudaUrl}${store._id}/`;

    try {
      let response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        body: JSON.stringify({ accountId, accountName, provider, amount, sellToken, postype, serialNumber, transID: transID || selectedTrans.transID }),
      });

      /* uiAlert(`Successfully pushed ${amount} to ${accountName} via ${provider}`, "success"); */

      /*    return { success: true, message: "Transaction successful" }; */
      const data = await response.json().catch(() => null);

      if (!response.ok) {
        return {
          success: false,
          message: data?.message || "Failed to push to terminal",
          data,
        };
      }

      return {
        success: true,
        message: data?.message || (response.ok ? "Transaction successful" : "Failed to push to terminal"),
        data,
      };
    } catch (error) {
      console.error("Error pushing to terminal:", error);
      return {
        success: false,
        message: error.message || "Failed to push to terminal",
        error,
      };
    }
  };

  return (
    <>
      {/*   <div style={{ backgroundColor: "#F9F9F9" }} className='checkStockWrapper ShowCheckStockWrapper'>
        {loading ? (
          <div>
            <Spinner position={"absolute"} transparent={false} backgroundColor={"#F9F9F9"} />
          </div>
        ) : selectedTrans ? (
          <div
            style={{
              height: "100%",
              minHeight: "initial",
              padding: "10px",
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%)",
              minHeight: "100%",
              height: "fit-content",
            }}
          >
            <div className='txn-dtl-v2-header'>
              <div className='txn-dtl-v2-header-content'>
                <span className='txn-dtl-v2-header-label'>Transaction ID</span>
                <span className='txn-dtl-v2-header-id'>{truncateTransID(transID)}</span>
              </div>
              <button className='txn-dtl-v2-info-icon-btn' onClick={() => setShowMobileOverlay(true)} title='View Details'>
                <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' />
                  <circle cx='12' cy='12' r='3' />
                </svg>
              </button>
              <button
                onClick={async () => {
                  console.log("closing queried transaction, showing count", count);
                  if (count > 0) {
                    console.log("syncing offline queue in queried transaction");
                    await syncOfflineQueue();
                    fetchTodayTransaction();
                    fetchGoodsOnLoan();
                    updateShowQueriedTrans(false);
                    setSelectedTransact(null);
                  } else {
                    console.log("no offline queue to sync in queried transaction");
                    fetchTodayTransaction();
                    fetchGoodsOnLoan();
                    updateShowQueriedTrans(false);
                    setSelectedTransact(null);
                  }
                }}
                className='txn-dtl-v2-close-btn'
              >
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <line x1='18' y1='6' x2='6' y2='18' />
                  <line x1='6' y1='6' x2='18' y2='18' />
                </svg>
              </button>
            </div>
            <div className='queriedTransactionDIv'>
              <div style={{ backgroundColor: "white" }} className='queryDetailLeftDiv'>
                <button className='txn-dtl-v2-panel-header' onClick={() => setShowProducts(!showProducts)}>
                  <div className='txn-dtl-v2-panel-header-content'>
                    <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#667eea' strokeWidth='2'>
                      <path d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' />
                    </svg>
                    <h2 className='txn-dtl-v2-panel-title'>Products ({selectedTrans.products.length})</h2>
                  </div>
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#64748b'
                    strokeWidth='2'
                    style={{ transform: showProducts ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.3s" }}
                  >
                    <polyline points='6 9 12 15 18 9' />
                  </svg>
                </button>
                <div className='txn-dtl-v2-search-container'>
                  <input
                    type='text'
                    placeholder='Search products...'
                    className='txn-dtl-v2-search-input'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className='txn-dtl-v2-search-btn'>
                    <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                      <circle cx='11' cy='11' r='8' />
                      <path d='m21 21-4.35-4.35' />
                    </svg>
                  </button>
                </div>
                {showProducts && (
                  <div className='transItemsListdd233 txn-dtl-v2-panel-content-products'>
                    <div className='txn-dtl-v2-products-grid'>
                      {selectedTrans &&
                        selectedTrans.products
                          .filter((product) => product.name.toLowerCase().includes(searchQuery.toLowerCase()))
                          .map((product, i) => {
                            let imageUrl = `${product.productImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_122/${
                              product.productImage.split("/upload/")[1]
                            }`;
                            return (
                              <EachProductSold
                                key={i}
                                product={product}
                                whichOperation={selectedTrans.operationType.whichOperation}
                                transId={selectedTrans.transID}
                                updateSelectedTrans={setSelectedTrans}
                                customer={selectedTrans.customer.fullName}
                                setAlertDisplay={setAlertDisplay}
                                fetchTodayTransaction={fetchTodayTransaction}
                                queriedTrans={true}
                                currency={currency}
                              />
                            );
                          })}
                    </div>
                  </div>
                )}
                {selectedTrans && (
                  <div className='returnItemOrSupButtonDiv returnStickybtnDiv'>
                    {selectedTrans.operationType.whichOperation === "loan" ? (
                      selectedTrans.operationType?.balance === 0 ? (
                        <button style={{ opacity: "0.5", cursor: "not-allowed" }}> Clear loan </button>
                      ) : (
                        <div>
                          <button className='clearloanBTN' onClick={() => setOpenClearLoanModal(true)}>
                            Clear loan
                          </button>
                          <button onClick={() => setOpenSplitPaymentModal(true)}> Split payment</button>
                        </div>
                      )
                    ) : selectedTrans.transactionDetails.deliveryStatus === "returned" ? (
                      <button style={{ opacity: "0.5", cursor: "not-allowed" }}> Return All item</button>
                    ) : (
                      <button onClick={returnAllProduct}> Return All item</button>
                    )}
                    {selectedTrans.operationType?.whichOperation === "loan" ? (
                      selectedTrans.operationType?.balance === 0 ? (
                        <button style={{ opacity: "0.5", cursor: "not-allowed" }}>Extend due date</button>
                      ) : (
                        <button onClick={() => setOpenExtendLoanModal(true)}>Extend due date</button>
                      )
                    ) : selectedTrans.transactionDetails.deliveryStatus === "notSupplied" ? (
                      <button onClick={supplyAllItem}> Supply All item</button>
                    ) : (
                      <button style={{ opacity: "0.5", cursor: "not-allowed" }}> SupplyAll item</button>
                    )}
                  </div>
                )}
              </div>

              <div style={{ padding: " 20px", backgroundColor: "white", borderRadius: "8px" }}>
                <div className='TdetailBtnDivs'></div>

                <div style={{ paddingTop: "0" }} className='detailsCusDi37463'>
                  <p className='dTit463'>Customer Information</p>
                  <div className='custcont37uD'>
                    <div className='EacDet35jdh'>
                      <span>Name</span>
                      <span>{selectedTrans.customer.fullName ? selectedTrans.customer.fullName : "no"}</span>
                    </div>
                    <div className='EacDet35jdh'>
                      <span>Email</span>
                      <span>{selectedTrans.customer.email ? selectedTrans.customer.email : "no"}</span>
                    </div>
                    <div className='EacDet35jdh'>
                      <span>Phone number</span>
                      <span>{selectedTrans.customer.phoneNumber ? selectedTrans.customer.phoneNumber : "no"}</span>
                    </div>
                    <div style={{ border: "none" }} className='EacDet35jdh'>
                      <span>Address</span>
                      <span>{selectedTrans.customer.address ? selectedTrans.customer.address : "no"}</span>
                    </div>
                  </div>
                </div>
                <div className='detailsCusDi37463'>
                  <p className='dTit463'>Transaction details</p>
                  <div className='custcont37uD'>
                    <div className='EacDet35jdh'>
                      <span>Date</span>
                      <span>{selectedTrans.transactionDetails.date.split("T")[0]}</span>
                    </div>
                    <div className='EacDet35jdh'>
                      <span>Delivery Status</span>

                      {selectedTrans?.transactionDetails.deliveryStatus === "supplied" ? (
                        <>
                          <div className={`Tstatus  `}>
                            <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                            <span> Supplied</span>
                          </div>
                        </>
                      ) : selectedTrans?.transactionDetails.deliveryStatus === "returned" ? (
                        <div style={{ backgroundColor: "rgb(236, 236, 236)" }} className={`Tstatus  `}>
                          <span style={{ height: "6px", width: "6px", backgroundColor: "rgb(96, 96, 96)", borderRadius: "40px" }}></span>
                          <span style={{ color: "rgb(78, 78, 78)" }}> returned</span>
                        </div>
                      ) : (
                        <div style={{ backgroundColor: "rgba(254, 246, 245, 1)" }} className={`Tstatus TstatusLoanNotCleared `}>
                          <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(244, 67, 54, 1)", borderRadius: "40px" }}></span>
                          <span style={{ color: "rgba(244, 67, 54, 1)" }}> Not supplied</span>
                        </div>
                      )}
                    </div>

                   

                    <div className='EacDet35jdh'>
                      <span>Sold by</span>
                      <span>{selectedTrans.soldBy.fullName ? selectedTrans.soldBy.fullName : "Admin"}</span>
                    </div>

                    <div className='EacDet35jdh'>
                      <span>Payment mode</span>
                      <span>{selectedTrans.transactionDetails.paymentMode}</span>
                    </div>

                    <div className='EacDet35jdh'>
                      <span>Sub total</span>
                      <span>
                        {selectedTrans.transactionDetails.subTotal
                          ? selectedTrans.transactionDetails.subTotal?.toLocaleString()
                          : selectedTrans.transactionDetails.totalAmount?.toLocaleString()}
                      </span>
                    </div>


                    <div className='EacDet35jdh'>
                      <span>Discount</span>
                      <span>
                        {" "}
                        {currency}
                        {parseInt(selectedTrans.transactionDetails.discount || 0)?.toLocaleString()}{" "}
                      </span>
                    </div>

                   

                    <div className='EacDet35jdh'>
                      <span>VAT({selectedTrans.transactionDetails.vatPercentage?.$numberDecimal || 0}%) </span>
                      <span>
                        {" "}
                        {currency}
                        {Number(selectedTrans.transactionDetails.vat || 0)?.toLocaleString()}{" "}
                      </span>
                    </div>

                    {Number(selectedTrans.transactionDetails.clearedbalance || 0) > 0 && (
                      <div className='EacDet35jdh'>
                        <span>Amount from old balance </span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.clearedbalance || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    )}

                    {Number(selectedTrans.transactionDetails.deliveryFee || 0) > 0 ? (
                      <div className='EacDet35jdh'>
                        <span>DeliveryFee:</span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.deliveryFee || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {Number(selectedTrans.transactionDetails.serviceCharge || 0) > 0 ? (
                      <div className='EacDet35jdh'>
                        <span>Service charge:</span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.serviceCharge || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {Number(selectedTrans.transactionDetails.extraPayment || 0) > 0 ? (
                      <div className='EacDet35jdh'>
                        <span>Extra payment (Off record debt):</span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.extraPayment || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}

                    {selectedTrans.operationType.whichOperation === "loan" && (
                      <>
                        <div className='EacDet35jdh'>
                          <span>Inital Pay</span>
                          <span>
                            {currency}
                            {selectedTrans.operationType.intialPayment.toLocaleString()}
                          </span>
                        </div>
                        {selectedTrans.operationType.clearedAmount && selectedTrans.operationType.whichOperation === "loan" && (
                          <div className='EacDet35jdh'>
                            <span>Cleared amount </span>
                            <span>
                              {currency}
                              {selectedTrans.operationType.clearedAmount.toLocaleString()}
                            </span>
                          </div>
                        )}
                        <div className='EacDet35jdh'>
                          <span>Balance </span>
                          <span>
                            {currency}
                            {selectedTrans.operationType.balance.toLocaleString()}{" "}
                          </span>
                        </div>
                      </>
                    )}
                    {selectedTrans.operationType.whichOperation === "loan" && selectedTrans.operationType.balance !== 0 && (
                      <>
                        <div className='EacDet35jdh'>
                          <span style={{ color: "rgb(226, 22, 22)" }}>Due date </span>
                          <span style={{ color: "rgb(226, 22, 22)" }}>{selectedTrans.operationType.dateToPay}</span>
                        </div>
                      </>
                    )}
                    {selectedTrans.operationType.balance === 0 && (
                      <>
                        <div className='EacDet35jdh'>
                          <span>Amount Cleared</span>
                          <span>{selectedTrans.operationType.clearedAmount.toLocaleString()}</span>
                        </div>
                        <div className='EacDet35jdh'>
                          <span>Date Cleared</span>
                          <span>{selectedTrans.operationType.clearedDate}</span>
                        </div>
                      </>
                    )}
                    <div style={{ border: "none" }} className='EacDet35jdh'>
                      <span>Total price</span>
                      <span>
                        {" "}
                        {currency}
                        {selectedTrans.transactionDetails.subTotal
                          ? selectedTrans.transactionDetails.totalAmount?.toLocaleString()
                          : (
                              parseInt(selectedTrans.transactionDetails.totalAmount) - Number(selectedTrans.transactionDetails.discount || 0)
                            )?.toLocaleString()}{" "}
                      </span>
                    </div>
                  </div>
                </div>
                {selectedTrans?.transactionDetails.deliveryStatus === "notSupplied" && selectedTrans.operationType.whichOperation === "loan" && (
                  <button
                    onClick={supplyAllItem}
                    style={{
                      marginBottom: "10px",
                      width: "100%",
                      padding: "16px",
                    }}
                    className='sell-items-btn'
                    disabled={loadingOper}
                  >
                    {loadingOper ? <ButtonLoader /> : "Mark as supplied"}
                  </button>
                )}
                {selectedTrans.operationType.whichOperation === "loan" && selectedTrans?.transactionDetails.deliveryStatus !== "returned" && (
                  <button
                    onClick={returnAllProduct}
                    style={{
                      background: "linear-gradient(135deg,rgb(185, 51, 41) 0%,rgb(244, 67, 54) 100%)",
                      width: "100%",
                      padding: "16px",
                    }}
                    className='sell-items-btn'
                    disabled={loadingOper}
                  >
                    {loadingOper ? <ButtonLoader /> : "Return all items"}
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div
              onClick={() => {
                //fetchTodayTransaction();
                //fetchGoodsOnLoan();
                updateShowQueriedTrans(false);
              }}
              className='closeCheckSalesDiv'
            >
              Close
            </div>
            <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424141/static%20images%20storelens/noqueriedtransfound_on1yis.png"} />
          </div>
        )}
      </div>

      {showMobileOverlay && (
        <div className='txn-dtl-v2-mobile-overlay' onClick={() => setShowMobileOverlay(false)}>
          <div className='txn-dtl-v2-mobile-overlay-content' onClick={(e) => e.stopPropagation()}>
            <div className='txn-dtl-v2-mobile-overlay-header'>
              <h2>Transaction Information</h2>
              <button className='mobile-overlay-close' onClick={() => setShowMobileOverlay(false)}>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <line x1='18' y1='6' x2='6' y2='18' />
                  <line x1='6' y1='6' x2='18' y2='18' />
                </svg>
              </button>
            </div>

            <div className='txn-dtl-v2-mobile-overlay-body'>
             

              <div style={{ paddingTop: "0" }} className='detailsCusDi37463'>
                <p className='dTit463'>Customer Information</p>
                <div className='custcont37uD'>
                  <div className='EacDet35jdh'>
                    <span>Name</span>
                    <span>{selectedTrans.customer.fullName ? selectedTrans.customer.fullName : "no"}</span>
                  </div>
                  <div className='EacDet35jdh'>
                    <span>Email</span>
                    <span>{selectedTrans.customer.email ? selectedTrans.customer.email : "no"}</span>
                  </div>
                  <div className='EacDet35jdh'>
                    <span>Phone number</span>
                    <span>{selectedTrans.customer.phoneNumber ? selectedTrans.customer.phoneNumber : "no"}</span>
                  </div>
                  <div style={{ border: "none" }} className='EacDet35jdh'>
                    <span>Address</span>
                    <span>{selectedTrans.customer.address ? selectedTrans.customer.address : "no"}</span>
                  </div>
                </div>
              </div>

              <div className='detailsCusDi37463'>
                <p className='dTit463'>Transaction details</p>
                <div className='custcont37uD'>
                  <div className='EacDet35jdh'>
                    <span>Date</span>
                    <span>{selectedTrans.transactionDetails.date.split("T")[0]}</span>
                  </div>
                  <div className='EacDet35jdh'>
                    <span>Delivery Status</span>

                    {selectedTrans?.transactionDetails.deliveryStatus === "supplied" ? (
                      <>
                        <div className={`Tstatus  `}>
                          <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                          <span> Supplied</span>
                        </div>
                      </>
                    ) : selectedTrans?.transactionDetails.deliveryStatus === "returned" ? (
                      <div style={{ backgroundColor: "rgb(236, 236, 236)" }} className={`Tstatus  `}>
                        <span style={{ height: "6px", width: "6px", backgroundColor: "rgb(96, 96, 96)", borderRadius: "40px" }}></span>
                        <span style={{ color: "rgb(78, 78, 78)" }}> returned</span>
                      </div>
                    ) : (
                      <div style={{ backgroundColor: "rgba(254, 246, 245, 1)" }} className={`Tstatus TstatusLoanNotCleared `}>
                        <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(244, 67, 54, 1)", borderRadius: "40px" }}></span>
                        <span style={{ color: "rgba(244, 67, 54, 1)" }}> Not supplied</span>
                      </div>
                    )}
                  </div>
                  <div className='EacDet35jdh'>
                    <span>Payment mode</span>
                    <span>{selectedTrans.transactionDetails.paymentMode}</span>
                  </div>
                  {selectedTrans.operationType.whichOperation === "loan" && (
                    <>
                      <div className='EacDet35jdh'>
                        <span>Inital Pay</span>
                        <span>
                          {currency}
                          {selectedTrans.operationType.intialPayment.toLocaleString()}
                        </span>
                      </div>
                      {selectedTrans.operationType.clearedAmount && selectedTrans.operationType.whichOperation === "loan" && (
                        <div className='EacDet35jdh'>
                          <span>Cleared amount </span>
                          <span>
                            {currency}
                            {selectedTrans.operationType.clearedAmount.toLocaleString()}
                          </span>
                        </div>
                      )}
                      <div className='EacDet35jdh'>
                        <span>Balance </span>
                        <span>
                          {currency}
                          {selectedTrans.operationType.balance.toLocaleString()}{" "}
                        </span>
                      </div>
                    </>
                  )}
                  {selectedTrans.operationType.whichOperation === "loan" && selectedTrans.operationType.balance !== 0 && (
                    <>
                      <div className='EacDet35jdh'>
                        <span style={{ color: "rgb(226, 22, 22)" }}>Due date </span>
                        <span style={{ color: "rgb(226, 22, 22)" }}>{selectedTrans.operationType.dateToPay}</span>
                      </div>
                    </>
                  )}
                  {selectedTrans.operationType.balance === 0 && (
                    <>
                      <div className='EacDet35jdh'>
                        <span>Amount Cleared</span>
                        <span>{selectedTrans.operationType.clearedAmount.toLocaleString()}</span>
                      </div>
                      <div className='EacDet35jdh'>
                        <span>Date Cleared</span>
                        <span>{selectedTrans.operationType.clearedDate}</span>
                      </div>
                    </>
                  )}
                  <div style={{ border: "none" }} className='EacDet35jdh'>
                    <span>Total price</span>
                    <span>
                      {" "}
                      {currency}
                      {parseInt(selectedTrans.transactionDetails.totalAmount.toLocaleString())}{" "}
                    </span>
                  </div>
                </div>
              </div>

              {selectedTrans?.transactionDetails.deliveryStatus === "notSupplied" && selectedTrans.operationType.whichOperation === "loan" && (
                <button
                  onClick={supplyAllItem}
                  style={{
                    marginBottom: "10px",
                    width: "100%",
                    padding: "16px",
                  }}
                  className='sell-items-btn'
                  disabled={loadingOper}
                >
                  {loadingOper ? <ButtonLoader /> : "Mark as supplied"}
                </button>
              )}
              {selectedTrans.operationType.whichOperation === "loan" && selectedTrans?.transactionDetails.deliveryStatus !== "returned" && (
                <button
                  onClick={returnAllProduct}
                  style={{
                    background: "linear-gradient(135deg,rgb(185, 51, 41) 0%,rgb(244, 67, 54) 100%)",
                    width: "100%",
                    padding: "16px",
                  }}
                  className='sell-items-btn'
                  disabled={loadingOper}
                >
                  {loadingOper ? <ButtonLoader /> : "Return all items"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {openClearLoanModal && (
        <div className='confirmLoanModal'>
          <div className='modaltoconfirmClear'>
            <h3>Are you sure you want to clear this loan?</h3>
            <div className='askagecongo3'>
              <p>Customer has paid up the remaining balance of</p>
              <span>{selectedTrans.operationType?.balance}</span>
            </div>
            <div className='askagecongo3divAfter'>
              <p>Select payment mode</p>
              <select value={loanPaymentMode} onChange={(e) => setLoanPaymentMode(e.target.value)}>
                <option value='cash'>Cash</option>
                <option value='card'>Card</option>
                <option value='mobilePay'>Mobile Pay</option>
              </select>
            </div>
            <div className='clearLooanModButnDiv'>
              <button onClick={() => setOpenClearLoanModal(false)}>Cancel</button>
              <button onClick={clearLoan}>Clear loan</button>
            </div>
          </div>
        </div>
      )}
      {openExtendLoanModal && (
        <div className='confirmLoanModal'>
          <div style={{ height: "240px" }} className='modaltoconfirmClear'>
            <h3>Extend loan due date</h3>
            <h5>loan is due on {selectedTrans.operationType.dateToPay}</h5>
            <input value={newExtendDate} onChange={(e) => setNewExtendDate(e.target.value)} className='inputExtenDtae1' type={"date"} />
            <div className='clearLooanModButnDiv'>
              <button onClick={() => setOpenExtendLoanModal(false)}>Cancel</button>
              {isExtendDateValid ? (
                <button onClick={extendLoanFun}>Extend loan</button>
              ) : (
                <button style={{ cursor: "not-allowed", opacity: "0.6" }} disabled>
                  Extend loan
                </button>
              )}
            </div>
          </div>
        </div>
      )}
      {openSplitPaymentModal && (
        <div className='confirmLoanModal'>
          <div style={{ height: "240px" }} className='modaltoconfirmClear'>
            <h3>How much did the customer pay</h3>
            <h5>Customer balance is: {selectedTrans.operationType?.balance}</h5>
            <input value={splitPaymentAmount} onChange={(e) => setSplitPaymentAmount(parseInt(e.target.value))} className='inputExtenDtae1' type={"number"} />
            <div className='askagecongo3divAfter'>
              <p>Select payment mode</p>
              <select value={loanPaymentMode} onChange={(e) => setLoanPaymentMode(e.target.value)}>
                <option value='cash'>Cash</option>
                <option value='card'>Card</option>
                <option value='mobilePay'>Mobile Pay</option>
              </select>
            </div>
            <div className='clearLooanModButnDiv'>
              <button onClick={() => setOpenSplitPaymentModal(false)}>Cancel</button>
              {isSplitPaymentAmountValid ? (
                <button onClick={splitPaymentFun}> Register payment</button>
              ) : (
                <button style={{ cursor: "not-allowed", opacity: "0.6" }} disabled>
                  Register payment
                </button>
              )}
            </div>
          </div>
        </div>
      )} */}

      <div style={{ backgroundColor: "#F9F9F9" }} className='checkStockWrapper ShowCheckStockWrapper'>
        {loading ? (
          <div>
            <Spinner position={"absolute"} transparent={false} backgroundColor={"#F9F9F9"} />
          </div>
        ) : selectedTrans ? (
          <div
            style={{
              height: "100%",
              minHeight: "initial",
              padding: "10px",
              background: "linear-gradient(135deg, #f5f7fa 0%, #e4e9f2 100%)",
              minHeight: "100%",
              height: "fit-content",
            }}
          >
            <div className='txn-dtl-v2-header'>
              <div className='txn-dtl-v2-header-content'>
                <span className='txn-dtl-v2-header-label'>Transaction ID</span>
                <span className='txn-dtl-v2-header-id'>{truncateID(selectedTrans._id)}</span>
              </div>

              <button className='txn-dtl-v2-info-icon-btn' onClick={() => setShowMobileOverlay(true)} title='View Details'>
                <svg width='22' height='22' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <path d='M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z' />
                  <circle cx='12' cy='12' r='3' />
                </svg>
              </button>
              <button
                onClick={async () => {
                  console.log("closing queried transaction, showing count", count);
                  if (count > 0) {
                    console.log("syncing offline queue in queried transaction");
                    await syncOfflineQueue();
                    fetchTodayTransaction();
                    fetchGoodsOnLoan();
                    updateShowQueriedTrans(false);
                    setSelectedTransact(null);
                  } else {
                    console.log("no offline queue to sync in queried transaction");
                    fetchTodayTransaction();
                    fetchGoodsOnLoan();
                    updateShowQueriedTrans(false);
                    setSelectedTransact(null);
                  }
                }}
                className='txn-dtl-v2-close-btn'
              >
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <line x1='18' y1='6' x2='6' y2='18' />
                  <line x1='6' y1='6' x2='18' y2='18' />
                </svg>
              </button>
            </div>
            <div className='queriedTransactionDIv'>
              <div style={{ backgroundColor: "white" }} className='queryDetailLeftDiv'>
                <button className='txn-dtl-v2-panel-header' onClick={() => setShowProducts(!showProducts)}>
                  <div className='txn-dtl-v2-panel-header-content'>
                    <svg width='20' height='20' viewBox='0 0 24 24' fill='none' stroke='#667eea' strokeWidth='2'>
                      <path d='M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z' />
                    </svg>
                    <h2 className='txn-dtl-v2-panel-title'>Products ({selectedTrans.products.length})</h2>
                  </div>
                  <svg
                    width='20'
                    height='20'
                    viewBox='0 0 24 24'
                    fill='none'
                    stroke='#64748b'
                    strokeWidth='2'
                    style={{ transform: showProducts ? "rotate(180deg)" : "rotate(0)", transition: "transform 0.3s" }}
                  >
                    <polyline points='6 9 12 15 18 9' />
                  </svg>
                </button>
                <div className='txn-dtl-v2-search-container'>
                  <input
                    type='text'
                    placeholder='Search products...'
                    className='txn-dtl-v2-search-input'
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                  <button className='txn-dtl-v2-search-btn'>
                    <svg width='18' height='18' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                      <circle cx='11' cy='11' r='8' />
                      <path d='m21 21-4.35-4.35' />
                    </svg>
                  </button>
                </div>
                {showProducts && (
                  <div className='transItemsListdd233 txn-dtl-v2-panel-content-products'>
                    <div className='txn-dtl-v2-products-grid'>
                      {selectedTrans &&
                        selectedTrans.products
                          .filter((product) => product.name.toLowerCase().includes(searchQuery.toLowerCase()))
                          .map((product, i) => {
                            let imageUrl = `${product.productImage.split("/upload/")[0]}/upload/f_auto,q_auto,w_122/${
                              product.productImage.split("/upload/")[1]
                            }`;
                            return (
                              <EachProductSold
                                key={i}
                                product={product}
                                whichOperation={selectedTrans.operationType.whichOperation}
                                transId={selectedTrans.transID}
                                updateSelectedTrans={setSelectedTrans}
                                customer={selectedTrans.customer.fullName}
                                setAlertDisplay={setAlertDisplay}
                                fetchTodayTransaction={fetchTodayTransaction}
                                queriedTrans={true}
                                currency={currency}
                              />
                            );
                          })}
                    </div>
                  </div>
                )}
                {selectedTrans && selectedTrans.transactionDetails.deliveryStatus !== "returned" && (
                  <div className='returnItemOrSupButtonDiv returnStickybtnDiv' style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
                    {selectedTrans.operationType.whichOperation === "loan" ? (
                      selectedTrans.operationType?.balance === 0 ? (
                        <ActionBtn variant='blue' icon='check' label='Clear credit' disabled />
                      ) : (
                        <>
                          <ActionBtn
                            variant='blue'
                            icon='check'
                            label='Clear credit'
                            onClick={() => {
                              console.log("opening clear loan modal");
                              setOpenClearLoanModal(true);
                            }}
                          />
                          <ActionBtn variant='navy' icon='split' label='Split payment' onClick={() => setOpenSplitPaymentModal(true)} />
                        </>
                      )
                    ) : (
                      <ActionBtn variant='red' icon='undo' label='Return All item' onClick={returnAllProduct} />
                    )}
                    {selectedTrans.operationType?.whichOperation === "loan" ? (
                      <ActionBtn
                        variant='outline'
                        icon='clock'
                        label='Extend due date'
                        onClick={() => setOpenExtendLoanModal(true)}
                        disabled={selectedTrans.operationType?.balance === 0}
                      />
                    ) : (
                      <ActionBtn
                        variant='outline'
                        icon='package'
                        label='Supply All item'
                        onClick={supplyAllItem}
                        disabled={selectedTrans.transactionDetails.deliveryStatus !== "notSupplied"}
                      />
                    )}
                  </div>
                )}
              </div>

              <div style={{ padding: " 20px", backgroundColor: "white", borderRadius: "8px" }}>
                <div className='TdetailBtnDivs'></div>

                <div style={{ paddingTop: "0" }} className='detailsCusDi37463'>
                  <p className='dTit463'>Customer Information</p>
                  <div className='custcont37uD'>
                    <div className='EacDet35jdh'>
                      <span>Name</span>
                      <span>{selectedTrans.customer.fullName ? selectedTrans.customer.fullName : "no"}</span>
                    </div>
                    <div className='EacDet35jdh'>
                      <span>Email</span>
                      <span>{selectedTrans.customer.email ? selectedTrans.customer.email : "no"}</span>
                    </div>
                    <div className='EacDet35jdh'>
                      <span>Phone number</span>
                      <span>{selectedTrans.customer.phoneNumber ? selectedTrans.customer.phoneNumber : "no"}</span>
                    </div>
                    <div style={{ border: "none" }} className='EacDet35jdh'>
                      <span>Address</span>
                      <span>{selectedTrans.customer.address ? selectedTrans.customer.address : "no"}</span>
                    </div>
                  </div>
                </div>
                <div className='detailsCusDi37463'>
                  <p className='dTit463'>Transaction details</p>
                  <div className='custcont37uD'>
                    <div className='EacDet35jdh'>
                      <span>Date</span>
                      <span>{selectedTrans.transactionDetails.date.split("T")[0]}</span>
                    </div>
                    <div className='EacDet35jdh'>
                      <span>Delivery Status</span>

                      {selectedTrans?.transactionDetails.deliveryStatus === "supplied" ? (
                        <>
                          <div className={`Tstatus  `}>
                            <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                            <span> Supplied</span>
                          </div>
                        </>
                      ) : selectedTrans?.transactionDetails.deliveryStatus === "returned" ? (
                        <div style={{ backgroundColor: "rgb(236, 236, 236)" }} className={`Tstatus  `}>
                          <span style={{ height: "6px", width: "6px", backgroundColor: "rgb(96, 96, 96)", borderRadius: "40px" }}></span>
                          <span style={{ color: "rgb(78, 78, 78)" }}> returned</span>
                        </div>
                      ) : (
                        <div style={{ backgroundColor: "rgba(254, 246, 245, 1)" }} className={`Tstatus TstatusLoanNotCleared `}>
                          <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(244, 67, 54, 1)", borderRadius: "40px" }}></span>
                          <span style={{ color: "rgba(244, 67, 54, 1)" }}> Not supplied</span>
                        </div>
                      )}
                    </div>

                    <div className='EacDet35jdh'>
                      <span>Sold by</span>
                      <span>{selectedTrans.soldBy.fullName ? selectedTrans.soldBy.fullName : "Admin"}</span>
                    </div>

                    {/* subTotoal */}
                    <div className='EacDet35jdh'>
                      <span>Sub total</span>
                      <span>
                        {selectedTrans.transactionDetails.subTotal
                          ? selectedTrans.transactionDetails.subTotal?.toLocaleString()
                          : selectedTrans.transactionDetails.totalAmount?.toLocaleString()}
                      </span>
                    </div>

                    {/* discount */}

                    <div className='EacDet35jdh'>
                      <span>Discount</span>
                      <span>
                        {" "}
                        {currency}
                        {parseInt(selectedTrans.transactionDetails.discount || 0)?.toLocaleString()}{" "}
                      </span>
                    </div>

                    {/* vat */}

                    <div className='EacDet35jdh'>
                      <span>VAT({selectedTrans.transactionDetails.vatPercentage?.$numberDecimal || 0}%) </span>
                      <span>
                        {" "}
                        {currency}
                        {Number(selectedTrans.transactionDetails.vat || 0)?.toLocaleString()}{" "}
                      </span>
                    </div>

                    {Number(selectedTrans.transactionDetails.clearedbalance || 0) > 0 && (
                      <div className='EacDet35jdh'>
                        <span>Amount from old balance </span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.clearedbalance || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    )}
                    {Number(selectedTrans.transactionDetails.deliveryFee || 0) > 0 ? (
                      <div className='EacDet35jdh'>
                        <span>DeliveryFee:</span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.deliveryFee || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {Number(selectedTrans.transactionDetails.serviceCharge || 0) > 0 ? (
                      <div className='EacDet35jdh'>
                        <span>Service charge:</span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.serviceCharge || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}
                    {Number(selectedTrans.transactionDetails.extraPayment || 0) > 0 ? (
                      <div className='EacDet35jdh'>
                        <span>Extra payment (Off record debt):</span>
                        <span>
                          {" "}
                          {currency}
                          {Number(selectedTrans.transactionDetails.extraPayment || 0)?.toLocaleString()}{" "}
                        </span>
                      </div>
                    ) : (
                      ""
                    )}

                    {selectedTrans.operationType.whichOperation === "loan" && (
                      <>
                        <div className='EacDet35jdh'>
                          <span>Inital Pay</span>
                          <span>
                            {currency}
                            {selectedTrans.operationType.intialPayment.toLocaleString()}
                          </span>
                        </div>
                        {selectedTrans.operationType.clearedAmount && selectedTrans.operationType.whichOperation === "loan" && (
                          <div className='EacDet35jdh'>
                            <span>Cleared amount </span>
                            <span>
                              {currency}
                              {selectedTrans.operationType.clearedAmount.toLocaleString()}
                            </span>
                          </div>
                        )}
                        <div className='EacDet35jdh'>
                          <span>Balance </span>
                          <span>
                            {currency}
                            {selectedTrans.operationType.balance.toLocaleString()}{" "}
                          </span>
                        </div>
                      </>
                    )}
                    {selectedTrans.operationType.whichOperation === "loan" && selectedTrans.operationType.balance !== 0 && (
                      <>
                        <div className='EacDet35jdh'>
                          <span style={{ color: "rgb(226, 22, 22)" }}>Due date </span>
                          <span style={{ color: "rgb(226, 22, 22)" }}>{selectedTrans.operationType.dateToPay}</span>
                        </div>
                      </>
                    )}
                    {selectedTrans.operationType.balance === 0 && (
                      <>
                        <div className='EacDet35jdh'>
                          <span>Amount Cleared</span>
                          <span>{selectedTrans.operationType.clearedAmount.toLocaleString()}</span>
                        </div>
                        <div className='EacDet35jdh'>
                          <span>Date Cleared</span>
                          <span>{selectedTrans.operationType.clearedDate}</span>
                        </div>
                      </>
                    )}
                    <div style={{ border: "none" }} className='EacDet35jdh'>
                      <span>Total price</span>
                      <span>
                        {" "}
                        {currency}
                        {selectedTrans.transactionDetails.subTotal
                          ? selectedTrans.transactionDetails.totalAmount?.toLocaleString()
                          : (
                              parseInt(selectedTrans.transactionDetails.totalAmount) - Number(selectedTrans.transactionDetails.discount || 0)
                            )?.toLocaleString()}{" "}
                      </span>
                    </div>
                  </div>
                </div>

                <div className='detailsCusDi37463'>
                  <p className='dTit463'>Payments</p>
                  <PaymentsBreakdown
                    payments={selectedTrans.transactionDetails.payments}
                    paymentMode={selectedTrans.transactionDetails.paymentMode}
                    currency={currency}
                  />
                </div>
                {selectedTrans?.transactionDetails.deliveryStatus === "notSupplied" && selectedTrans.operationType.whichOperation === "loan" && (
                  <button
                    onClick={supplyAllItem}
                    style={{
                      marginBottom: "10px",
                      width: "100%",
                      padding: "16px",
                    }}
                    className='sell-items-btn'
                    disabled={loadingOper}
                  >
                    {loadingOper ? <ButtonLoader /> : "Mark as supplied"}
                  </button>
                )}
                {selectedTrans.operationType.whichOperation === "loan" && selectedTrans?.transactionDetails.deliveryStatus !== "returned" && (
                  <button
                    onClick={returnAllProduct}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      gap: "8px",
                      background: "linear-gradient(135deg,rgb(185, 51, 41) 0%,rgb(244, 67, 54) 100%)",
                      width: "100%",
                      padding: "16px",
                    }}
                    className='sell-items-btn'
                    disabled={loadingOper}
                  >
                    {loadingOper ? (
                      <ButtonLoader />
                    ) : (
                      <>
                        <ActionBtnIcon type='undo' />
                        Return all items
                      </>
                    )}
                  </button>
                )}
              </div>
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div
              onClick={() => {
                updateShowQueriedTrans(false);
              }}
              className='closeCheckSalesDiv'
            >
              Close
            </div>
            <img src={"https://res.cloudinary.com/ebuka1122/image/upload/v1710424141/static%20images%20storelens/noqueriedtransfound_on1yis.png"} />
          </div>
        )}
      </div>

      {/* Mobile Overlay */}
      {showMobileOverlay && (
        <div className='txn-dtl-v2-mobile-overlay' onClick={() => setShowMobileOverlay(false)}>
          <div className='txn-dtl-v2-mobile-overlay-content' onClick={(e) => e.stopPropagation()}>
            <div className='txn-dtl-v2-mobile-overlay-header'>
              <h2>Transaction Information</h2>
              <button className='mobile-overlay-close' onClick={() => setShowMobileOverlay(false)}>
                <svg width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2'>
                  <line x1='18' y1='6' x2='6' y2='18' />
                  <line x1='6' y1='6' x2='18' y2='18' />
                </svg>
              </button>
            </div>

            <div className='txn-dtl-v2-mobile-overlay-body'>
              {/* Customer Information */}

              <div style={{ paddingTop: "0" }} className='detailsCusDi37463'>
                <p className='dTit463'>Customer Information</p>
                <div className='custcont37uD'>
                  <div className='EacDet35jdh'>
                    <span>Name</span>
                    <span>{selectedTrans.customer.fullName ? selectedTrans.customer.fullName : "no"}</span>
                  </div>
                  <div className='EacDet35jdh'>
                    <span>Email</span>
                    <span>{selectedTrans.customer.email ? selectedTrans.customer.email : "no"}</span>
                  </div>
                  <div className='EacDet35jdh'>
                    <span>Phone number</span>
                    <span>{selectedTrans.customer.phoneNumber ? selectedTrans.customer.phoneNumber : "no"}</span>
                  </div>
                  <div style={{ border: "none" }} className='EacDet35jdh'>
                    <span>Address</span>
                    <span>{selectedTrans.customer.address ? selectedTrans.customer.address : "no"}</span>
                  </div>
                </div>
              </div>

              {/* Transaction Details */}

              <div className='detailsCusDi37463'>
                <p className='dTit463'>Transaction details</p>
                <div className='custcont37uD'>
                  <div className='EacDet35jdh'>
                    <span>Date</span>
                    <span>{selectedTrans.transactionDetails.date.split("T")[0]}</span>
                  </div>
                  <div className='EacDet35jdh'>
                    <span>Delivery Status</span>

                    {selectedTrans?.transactionDetails.deliveryStatus === "supplied" ? (
                      <>
                        <div className={`Tstatus  `}>
                          <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(2, 122, 72, 1)", borderRadius: "40px" }}></span>
                          <span> Supplied</span>
                        </div>
                      </>
                    ) : selectedTrans?.transactionDetails.deliveryStatus === "returned" ? (
                      <div style={{ backgroundColor: "rgb(236, 236, 236)" }} className={`Tstatus  `}>
                        <span style={{ height: "6px", width: "6px", backgroundColor: "rgb(96, 96, 96)", borderRadius: "40px" }}></span>
                        <span style={{ color: "rgb(78, 78, 78)" }}> returned</span>
                      </div>
                    ) : (
                      <div style={{ backgroundColor: "rgba(254, 246, 245, 1)" }} className={`Tstatus TstatusLoanNotCleared `}>
                        <span style={{ height: "6px", width: "6px", backgroundColor: "rgba(244, 67, 54, 1)", borderRadius: "40px" }}></span>
                        <span style={{ color: "rgba(244, 67, 54, 1)" }}> Not supplied</span>
                      </div>
                    )}
                  </div>
                  {selectedTrans.operationType.whichOperation === "loan" && (
                    <>
                      <div className='EacDet35jdh'>
                        <span>Inital Pay</span>
                        <span>
                          {currency}
                          {selectedTrans.operationType.intialPayment.toLocaleString()}
                        </span>
                      </div>
                      {selectedTrans.operationType.clearedAmount && selectedTrans.operationType.whichOperation === "loan" && (
                        <div className='EacDet35jdh'>
                          <span>Cleared amount </span>
                          <span>
                            {currency}
                            {selectedTrans.operationType.clearedAmount.toLocaleString()}
                          </span>
                        </div>
                      )}
                      <div className='EacDet35jdh'>
                        <span>Balance </span>
                        <span>
                          {currency}
                          {selectedTrans.operationType.balance.toLocaleString()}{" "}
                        </span>
                      </div>
                    </>
                  )}
                  {selectedTrans.operationType.whichOperation === "loan" && selectedTrans.operationType.balance !== 0 && (
                    <>
                      <div className='EacDet35jdh'>
                        <span style={{ color: "rgb(226, 22, 22)" }}>Due date </span>
                        <span style={{ color: "rgb(226, 22, 22)" }}>{selectedTrans.operationType.dateToPay}</span>
                      </div>
                    </>
                  )}
                  {selectedTrans.operationType.balance === 0 && (
                    <>
                      <div className='EacDet35jdh'>
                        <span>Amount Cleared</span>
                        <span>{selectedTrans.operationType.clearedAmount.toLocaleString()}</span>
                      </div>
                      <div className='EacDet35jdh'>
                        <span>Date Cleared</span>
                        <span>{selectedTrans.operationType.clearedDate}</span>
                      </div>
                    </>
                  )}
                  <div style={{ border: "none" }} className='EacDet35jdh'>
                    <span>Total price</span>
                    <span>
                      {" "}
                      {currency}
                      {parseInt(selectedTrans.transactionDetails.totalAmount.toLocaleString())}{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className='detailsCusDi37463'>
                <p className='dTit463'>Payments</p>
                <PaymentsBreakdown
                  payments={selectedTrans.transactionDetails.payments}
                  paymentMode={selectedTrans.transactionDetails.paymentMode}
                  currency={currency}
                />
              </div>

              {selectedTrans?.transactionDetails.deliveryStatus === "notSupplied" && selectedTrans.operationType.whichOperation === "loan" && (
                <button
                  onClick={supplyAllItem}
                  style={{
                    marginBottom: "10px",
                    width: "100%",
                    padding: "16px",
                  }}
                  className='sell-items-btn'
                  disabled={loadingOper}
                >
                  {loadingOper ? <ButtonLoader /> : "Mark as supplied"}
                </button>
              )}
              {selectedTrans.operationType.whichOperation === "loan" && selectedTrans?.transactionDetails.deliveryStatus !== "returned" && (
                <button
                  onClick={returnAllProduct}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "8px",
                    background: "linear-gradient(135deg,rgb(185, 51, 41) 0%,rgb(244, 67, 54) 100%)",
                    width: "100%",
                    padding: "16px",
                  }}
                  className='sell-items-btn'
                  disabled={loadingOper}
                >
                  {loadingOper ? (
                    <ButtonLoader />
                  ) : (
                    <>
                      <ActionBtnIcon type='undo' />
                      Return all items
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </div>
      )}

      {openClearLoanModal && (
        <ClearLoanModal
          isOpen={openClearLoanModal}
          amount={selectedTrans.operationType?.balance}
          onCancel={() => {
            setOpenClearLoanModal(false);
          }}
          onConfirm={async ({ amount, paymentMode, payments }) => {
            await clearLoan(payments, paymentMode, amount);
          }}
          loanPaymentMode={loanPaymentMode}
          setLoanPaymentMode={setLoanPaymentMode}
          currency={currency}
          pushToTerminal={async (entry) => {
            return await pushToTerminal(entry);
          }}
          socket={socket}
        />
      )}
      {openExtendLoanModal && (
        <ExtendLoanModal
          isOpen={openExtendLoanModal}
          dueDate={selectedTrans.operationType.dateToPay}
          onCancel={() => {
            setOpenExtendLoanModal(false);
          }}
          onConfirm={async () => {
            await extendLoanFun();
          }}
          newExtendDate={newExtendDate}
          setNewExtendDate={setNewExtendDate}
        />
      )}

      {openSplitPaymentModal && (
        <RegisterPaymentModal
          isOpen={openSplitPaymentModal}
          balance={selectedTrans.operationType?.balance}
          onCancel={() => {
            setOpenSplitPaymentModal(false);
          }}
          onConfirm={async ({ splitPaymentAmount, loanPaymentMode, payment }) => {
            await splitPaymentFun(splitPaymentAmount, loanPaymentMode, payment);
          }}
          splitPaymentAmount={splitPaymentAmount}
          setSplitPaymentAmount={setSplitPaymentAmount}
          loanPaymentMode={loanPaymentMode}
          setLoanPaymentMode={setLoanPaymentMode}
          currency={currency}
          pushToTerminal={async (entry) => {
            return await pushToTerminal(entry);
          }}
          socket={socket}
          transID={selectedTrans.transID}
        />
      )}
    </>
  );
};

const computeDueLoan = (transactions) => {
  let dueLoanCount = transactions.reduce((acc, curr) => {
    if (curr.operationType.whichOperation === "loan" && curr.operationType.balance > 0 && curr.transactionDetails.deliveryStatus !== "returned") {
      let newDate = (new Date(curr.operationType.dateToPay) - new Date()) / 1000 / 60 / 60 / 24;
      if (Math.floor(newDate) === 0 || Math.floor(newDate) < 0) {
        acc++;
      }
    }
    return acc;
  }, 0);

  return dueLoanCount;
};

const computeNotSupplied = (transactions) => {
  let notSuppliedCount = transactions.reduce((acc, curr) => {
    if (curr.transactionDetails.deliveryStatus === "notSupplied") {
      acc++;
    }
    return acc;
  }, 0);

  return notSuppliedCount;
};

export const notSupllSVG = (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M16 1C7.71255 1 1 7.71253 1 16C1 24.2875 7.71255 31 16 31C24.2875 31 31.0001 24.2875 31.0001 16C31.0001 7.71246 24.2876 1 16 1ZM4.00004 16C4.00004 9.37001 9.37003 3.99996 16.0001 3.99996C18.7751 3.99996 21.3177 4.95248 23.3501 6.52749L6.5275 23.3501C4.95249 21.3175 4.00004 18.775 4.00004 16ZM16 28C13.225 28 10.6825 27.0475 8.65003 25.4725L25.4726 8.65001C27.0476 10.6825 28.0001 13.225 28.0001 16C28.0001 22.6301 22.6301 28 16 28Z'
      fill='#F44336'
    />
  </svg>
);

export const dueTodaySVG = (
  <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M5.33333 24C5.68696 24 6.02609 23.8595 6.27614 23.6095C6.52619 23.3594 6.66667 23.0203 6.66667 22.6667L6.66667 17.3333C6.66667 16.9797 6.52619 16.6406 6.27614 16.3905C6.02609 16.1405 5.68696 16 5.33333 16C4.97971 16 4.64057 16.1405 4.39052 16.3905C4.14048 16.6406 4 16.9797 4 17.3333L4 22.6667C4 23.0203 4.14048 23.3594 4.39052 23.6095C4.64057 23.8595 4.97971 24 5.33333 24Z'
      fill='#FF9F00'
    />
    <path
      d='M5.33325 30.6665C6.43782 30.6665 7.33325 29.7711 7.33325 28.6665C7.33325 27.5619 6.43782 26.6665 5.33325 26.6665C4.22868 26.6665 3.33325 27.5619 3.33325 28.6665C3.33325 29.7711 4.22868 30.6665 5.33325 30.6665Z'
      fill='#FF9F00'
    />
    <path
      d='M17.2132 1.33326C13.8882 1.06267 10.5704 1.93368 7.80701 3.80257C5.04367 5.67146 3.00001 8.42655 2.01324 11.6133C1.95123 11.8172 1.93901 12.033 1.97762 12.2426C2.01622 12.4523 2.10452 12.6496 2.23511 12.8181C2.3657 12.9865 2.53478 13.1212 2.72817 13.2109C2.92156 13.3005 3.13362 13.3425 3.34658 13.3333L6.66658 13.3333C7.37382 13.3333 8.0521 13.6142 8.55219 14.1143C9.05229 14.6144 9.33324 15.2927 9.33324 15.9999L9.33324 28.1999C9.33143 28.4535 9.40196 28.7023 9.53658 28.9172C9.67119 29.1322 9.86429 29.3042 10.0932 29.4133C12.3708 30.4177 14.8665 30.8259 17.3454 30.5995C19.8243 30.3731 22.2048 29.5195 24.2627 28.1191C26.3206 26.7187 27.9883 24.8176 29.1086 22.5947C30.2289 20.3719 30.7651 17.9005 30.6666 15.4133C30.5097 11.8351 29.0594 8.43541 26.5851 5.84583C24.1107 3.25626 20.7806 1.65278 17.2132 1.33326ZM21.3332 17.3333L15.9999 17.3333C15.6463 17.3333 15.3071 17.1928 15.0571 16.9427C14.8071 16.6927 14.6666 16.3535 14.6666 15.9999L14.6666 7.99992C14.6666 7.6463 14.8071 7.30716 15.0571 7.05712C15.3071 6.80707 15.6463 6.66659 15.9999 6.66659C16.3535 6.66659 16.6927 6.80707 16.9427 7.05712C17.1928 7.30716 17.3332 7.6463 17.3332 7.99992L17.3332 14.6666L21.3332 14.6666C21.6869 14.6666 22.026 14.8071 22.2761 15.0571C22.5261 15.3072 22.6666 15.6463 22.6666 15.9999C22.6666 16.3535 22.5261 16.6927 22.2761 16.9427C22.026 17.1928 21.6869 17.3333 21.3332 17.3333Z'
      fill='#FF9F00'
    />
  </svg>
);
export const truncateID = (id) => {
  /* 221020259a6b...228457 */
  if (id.length <= 10) return id;
  return id.substring(0, 10) + "..." + id.substring(id.length - 6);
};

export const clearLoanSvg = (
  <svg width='26' height='27' viewBox='0 0 26 27' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path d='M10.8508 1.04004L14.846 0.995817L14.9029 6.13379L10.9077 6.17801L10.8508 1.04004Z' fill='#4CAF50' />
    <path
      d='M21.9782 0.916898L17.1312 0.970549L17.188 6.10849C17.202 7.36901 16.1883 8.40541 14.9277 8.41936L10.9336 8.46357C9.67305 8.47752 8.63665 7.46382 8.6227 6.2033L8.56583 1.06536L3.71645 1.11903C1.83082 1.13991 0.305162 2.69972 0.326034 4.58534L0.528424 22.8699C0.549422 24.767 2.10911 26.2812 3.99473 26.2604L22.2565 26.0582C24.1534 26.0372 25.6679 24.489 25.6469 22.5919L25.4445 4.30731C25.4236 2.42168 23.8752 0.8959 21.9782 0.916898ZM16.6255 16.5942L12.9807 20.3205C12.7599 20.5462 12.4688 20.6611 12.1764 20.6643C11.884 20.6675 11.5904 20.5592 11.3647 20.3384L9.35905 18.3767C8.9077 17.9352 8.8997 17.2121 9.34116 16.7607C9.78262 16.3094 10.5058 16.3014 10.9571 16.7428L12.1459 17.9055L14.9916 14.9961C15.4331 14.5447 16.1562 14.5367 16.6076 14.9782C17.0589 15.4196 17.0669 16.1428 16.6255 16.5942Z'
      fill='#4CAF50'
    />
  </svg>
);

export const LoanAmtSVG = (
  <svg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='rgba(138, 43, 226, 1)'>
    <path
      id='government-budget_15859185'
      d='M8,22V14h2v6.512a8.65,8.65,0,0,1,2-5.365V14h1.893a4.35,4.35,0,0,1-.525-2V10h7.765a2.655,2.655,0,0,0-.6-.466L12.348,5.07c-.069-.038-.147-.054-.219-.086V4.026l3-1.944L10.129,0V4.884a2.769,2.769,0,0,0-.479.188L1.469,9.534A2.814,2.814,0,0,0,0,12.008V14H2v8H0v2H11.257a5.473,5.473,0,0,1-1.03-2ZM4,14H6v8H4Zm20,7.014A2.993,2.993,0,0,1,21,24H15a2.993,2.993,0,0,1-3-2.986,7.089,7.089,0,0,1,4.84-6.452A3.993,3.993,0,0,1,15.368,12h5.263a3.991,3.991,0,0,1-1.472,2.562A7.087,7.087,0,0,1,24,21.014Z'
    />
  </svg>
);
